module.exports = __webpack_public_path__ + "img/09-26-170.447a601a.jpg";